
import { defineComponent, ref } from "vue";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";
import Popper from "vue3-popper";
export default defineComponent({
  name: "topbar",
  components: {
    KTUserMenu,
    Popper,
  },
});
